module.exports = __webpack_public_path__ + "img/South Sudan.6eb906e4.gif";